/* eslint-disable no-console */
import axiosInstance, { endpoints } from '@utils/axios';

// ----------------------------------------------------------------------

export const fetchChannels = async () => {
  try {
    const response = await axiosInstance.get(
      endpoints.UTILITY.OPTIONS.CHANNELS
    );
    return response.data;
  } catch (error) {
    console.error('Error fetching channels:', error);
    throw error;
  }
};
export const fetchLocations = async () => {
  try {
    const response = await axiosInstance.get(
      endpoints.UTILITY.OPTIONS.LOCATIONS
    );
    return response.data;
  } catch (error) {
    console.error('Error fetching locations:', error);
    throw error;
  }
};

export const fetchCities = async (
  isGrowIntelEnable: boolean,
  aggreagtor?: string
) => {
  if (isGrowIntelEnable) {
    try {
      const response = await axiosInstance.get(
        endpoints.UTILITY.OPTIONS.CITIES(aggreagtor)
      );
      return response.data.cities;
    } catch (error) {
      console.error('Error fetching cities:', error);
      throw error;
    }
  }
  return [];
};

export const fetchBrands = async () => {
  try {
    const response = await axiosInstance.get(endpoints.BRAND.GET_BRANDS);
    return response.data;
  } catch (error) {
    console.error('Error fetching brands:', error);
    throw error;
  }
};

export const fetchBranches = async (channel: string, brandId: number) => {
  try {
    const response = await axiosInstance.get(endpoints.BRANCH.GET_BRANCHES, {
      params: { channel, brandId }
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching branches:', error);
    throw error;
  }
};
